export default __webpack_public_path__ + "static/media/img-o-n-building-wealth.5d3a726d.png";